var _require = require("./sliders"),
  initSlider = _require.initSlider;
document.addEventListener("DOMContentLoaded", function () {
  // Imported functions here
  initSlider();
});